var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flux-wrapper',{ref:"wrapper",attrs:{"size":_vm.wrapperSize,"css":_vm.wrapperCss}},[_c('flux-image',{ref:"left",attrs:{"image":_vm.left,"size":_vm.size}}),_c('flux-image',{ref:"right",attrs:{"image":_vm.right,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }